//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

angular.module('curalate').filter(
    'reallyReadableNumber', ['$filter', ($filter) => {
      return (num, maxLength) => {
        if (!num) {
          return num;
        }

        const prettyVal = $filter('number')(num, 0);
        if (prettyVal.length <= maxLength) {
          return prettyVal;
        } else {
          return $filter('readableNumber')(num);
        }
      };
    },
    ]);
